//  For each product on the page
document.querySelectorAll('.productAcc').forEach(async section => {
    const product = JSON.parse(section.querySelector(".productAccJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    const hasSticky = !!section.querySelector(".productAccSticky");


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

        // if multiple swipers
    const multipleSwiper = document.querySelector('.productV2VisualInner').classList.contains('multiple');
    let productSwiper;

    section.querySelectorAll('.productV2VisualSwiper').forEach((swiper, index) => {

        const navRoot = swiper.closest('.productV2VisualSwiperWrapItem') || swiper.closest('.productV2VisualSwiperWrap');
        const prevEl = navRoot?.querySelector('.productV2VisualNavButton--prev');
        const nextEl = navRoot?.querySelector('.productV2VisualNavButton--next');

        const swiperConfig = {
            slidesPerView: 1,
            spaceBetween: 20,
        };

        if (prevEl && nextEl) {
            swiperConfig.navigation = { prevEl, nextEl };
        }

        const swiperItem = new Swiper(swiper, swiperConfig);

        // mark product swiper if only one swiper
        if (index === 0) productSwiper = swiperItem;

        const thumbSection = navRoot?.querySelector('.productV2VisualThumbs') || swiper.parentElement?.querySelector('.productV2VisualThumbs');

        swiperItem.on('slideChange', function () {
            if (!swiper.querySelector(".productV2VisualSwiperSlide")) {
                return;
            }

            // update the thumbnail active class
            thumbSection?.querySelector(".productV2VisualThumbsSlide.active")?.classList.remove("active");
            thumbSection?.querySelectorAll(".productV2VisualThumbsSlide")[this.realIndex]?.classList.add("active");

            // pause all videos
            swiper.querySelectorAll(".productV2VisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        },)

        // play video on slide play click
        swiper.querySelectorAll(".productV2VisualSwiperSlide").forEach(element => {
            element.addEventListener("click", function () {
                // get video
                const video = this.closest(".productV2VisualSwiperSlide").querySelector("video");

                if (!video) {
                    return;
                }

                // remove play button if it hasn't already been removed
                this.querySelector(".productV2VisualSwiperSlidePlay")?.remove();

                // show controls
                video.controls = true;

                // play video
                video.play();
            });
        });

        // clicking a thumbnail goes to slide
        thumbSection?.querySelectorAll(".productV2VisualThumbsSlide ").forEach(element => {
            element.addEventListener("click", function () {
                if (this.classList.contains('active')) return;
                // update active status
                thumbSection?.querySelector(".productV2VisualThumbsSlide.active")?.classList.remove("active");
                this.classList.add('active');
                // change slide
                swiperItem.slideTo(this.dataset.index - 1);
            });
        });
    })

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            // update color title above selectors
            if (this.dataset.color && section.querySelector('.productAccOptionsItemColor')) {
                section.querySelector('.productAccOptionsItemColor').textContent = `${this.value}`
            }
            updateProduct().catch(e => console.error(e));
        });
    })

    let firstRun = true;

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];

            section.querySelectorAll(`.productAccOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelectorAll(".productAccAtc").forEach(el => el.disabled = true);
            section.querySelectorAll(".productAccAtcText").forEach(el => el.textContent = "NOT AVAILABLE");
            section.querySelectorAll(".productAccPurchaseShipping").forEach(el => el.style.display = "none");
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant?.featured_image && !firstRun) {
            // change active slide
            if (section.querySelector(".productV2VisualSwiper")) {
                productSwiper.slideTo(activeVariant.featured_image.position - 1);
            }
        }

        /**************
         Price
         ***************/

            // update price
        const priceText = price(activeVariant.price, true);
        const comparePrice = price(activeVariant.compare_at_price, true);
        // main price section
        section.querySelectorAll(".productAccPriceRegular").forEach(el => el.textContent = priceText);
        section.querySelectorAll(".productAccPriceCompare").forEach(el => el.textContent = activeVariant.compare_at_price > activeVariant.price ? comparePrice : "");
        section.querySelectorAll('.productAccPriceSale').forEach(el => activeVariant.compare_at_price > activeVariant.price ? el.classList.add('active') : el.classList.remove('active'))

        // sticky price section
        if (hasSticky) {
            section.querySelector(".productAccStickyInfoPrice").textContent = priceText;
            section.querySelector(".productAccStickyInfoCompare").textContent = activeVariant.compare_at_price > activeVariant.price ? comparePrice : "";
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock and available (Shopify availability check)
        if (activeVariant.available) {
            section.querySelectorAll(".productAccAtc").forEach(el => el.disabled = false);
            section.querySelectorAll(".productAccAtcText").forEach(el => el.textContent = "ADD TO CART");
            section.querySelectorAll(".productAccPurchaseShipping").forEach(el => el.style.display = "");
        } else {
            section.querySelectorAll(".productAccAtc").forEach(el => el.disabled = true);
            section.querySelectorAll(".productAccAtcText").forEach(el => el.textContent = "OUT OF STOCK");
            section.querySelectorAll(".productAccPurchaseShipping").forEach(el => el.style.display = "none");
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant?.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    await updateProduct().catch(e => console.error(e));
    firstRun = false;

    /**************
     Product ATC
     ***************/

    /**************
     Gift card recipient
     ***************/

    const recipient = section.querySelector(".productAccRecipient");
    const recipientCheckbox = recipient?.querySelector(".productAccRecipientCheckbox");
    const recipientFields = recipient?.querySelector(".productAccRecipientFields");
    const recipientError = recipient?.querySelector(".productAccRecipientError");

    recipientCheckbox?.addEventListener("change", function () {
        recipientFields.hidden = !this.checked;
        recipientError.hidden = true;
    });

    // returns line item properties, or null when the recipient email is invalid
    function recipientProperties() {
        if (!recipientCheckbox?.checked) return {};

        const email = recipientFields.querySelector('[data-property="Recipient email"]');
        if (!email.value.trim() || !email.checkValidity()) {
            recipientError.hidden = false;
            email.focus();
            return null;
        }
        recipientError.hidden = true;

        const properties = {};
        recipient.querySelectorAll("[data-property]").forEach(input => {
            if (input.type === "checkbox" || input.value.trim()) {
                properties[input.dataset.property] = input.type === "checkbox" ? input.value : input.value.trim();
            }
        });
        return properties;
    }

    async function addToCart() {
        if (!activeVariant?.available) return;

        const properties = recipientProperties();
        if (properties === null) {
            recipient.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        // add loading animation to both buttons
        section.querySelectorAll(".productAccAtc").forEach(el => el.classList.add("loading"));

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
                properties: properties,
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelectorAll(".productAccAtc").forEach(el => el.classList.remove("loading"));

        // open cart
        await openCart();
    }

    section.querySelectorAll('.productAccAtc').forEach(el => el.addEventListener("click", addToCart));

    /**************
     Sticky ATC
     ***************/

        // initial position
    let position = window.scrollY;
    // sticky element
    const sticky = section.querySelector(".productAccSticky");

    function stickyATCHandle() {
        // if pdp has scroll off screen, show the sticky atc
        // if scrolling up, hide the atc
        if (section.getBoundingClientRect().bottom < 0) {
            window.scrollY > position ? sticky.classList.add('active') : sticky.classList.remove('active');
        } else {
            sticky.classList.remove('active');
        }
        // new position
        position = window.scrollY;
    }

    // check on scroll
    window.addEventListener('scroll', stickyATCHandle);
    // check on load
    stickyATCHandle();

    /**************
     Dropdowns
     ***************/

    // setup dropdowns
    section.querySelectorAll(".productAccDropsItemButton").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     More info
     ***************/

    // if there is an info link, add listener
    if (section.querySelector('.productAccInfoLink')) {
        if (document.querySelector('#details')) {
            // give sections time to load
            setTimeout(() => {
                section.querySelector('.productAccInfoLink').addEventListener('click', () => {
                    document.querySelector('#details').scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    })
                })
            }, 500)
        } else {
            section.querySelector('.productAccInfoLink').remove();
        }
    }

    /******************
     Update both ratings
     *******************/

    //app only loads in to the first instance, give text ot both places
    setTimeout(() => {
        if (section.querySelector('.productAccTop.mobileOnly .productAccRatings .hero-rating')) {
            const ratings = section.querySelector('.productAccTop.mobileOnly .productAccRatings .hero-rating').textContent;
            if (ratings) {
                section.querySelector('.productAccTop.desktopOnly .productAccRatings .hero-rating').textContent = ratings;
            }
        }
    }, 1000)
});

